export default {
    logged: {
        title: '多元投資香港科技券商 TOP1',
        subTitle: '一站式投資全球',
        desc1: '復星國際（00656.HK）旗下，AI 驅動的 WEB5（WEB2+WEB3）綜合券商。',
        desc2: '持香港證監會頒發的1、2、4、6、9號牌照，首批獲得香港虛擬資產交易服務牌照券商。',
        desc3: '港美股、A股、加密貨幣、基金、債券、票據、RWA代幣化產品等應有盡有。',
        ljkh3m: '3分鐘極速開戶',
        zjjsqz: '最終解釋權歸復星財富控股所有',
        kh: '開戶',
        rj: '入金',
        kt: '開啟投資',
        lddesc1: '一站式投資全球，投資品類全覆蓋，產品豐富度香港科技券商TOP1。',
        lddesc2: '復星國際（00656.HK）旗下，AI 驅動的 WEB5（WEB2+WEB3）綜合券商。',
        lddesc3: '持香港證監會頒發的 1、2、4、6、9號牌照，首批獲得香港虛擬資產交易服務牌照券商。',
        user: '用戶',
        getReward: '獲得了開戶$0佣金獎勵',
        gpmgqyj: '港美股/期權永久',
        yj: '佣金',
        xsslyj1000hkd: '限時領 1000+HKD 獎賞',
        star: '星',
    },
    pageTitle: '復星國際證券開戶',
    title1: '0門檻',
    title2: '3分鐘極速開戶',
    oneAccount: '一個賬戶投資全球',
    advantage: '復星國際證券優勢',
    advantage1: '新人福利',
    des1: '開戶立享多重禮',
    advantage2: '交易便捷',
    des2: '支持快捷改單',
    advantage3: '港股打新',
    des3: '最高33倍融資',
    advantage4: '電子暗盤',
    des4: '成交快人一步',
    advantage5: '孖展賬戶',
    des5: '支持融資交易',
    advantage6: '免費行情',
    desLV2: '美股LV1串流報價',
    desLV1: '',
    hkLv2: '港股LV2高級行情',
    usLv1: '美股LV1高級行情',
    usdes: '美股LV1串流報價',
    advantage7: '資質合規',
    des7: '持香港證監會頒發 1/2/4/6/9號牌照',
    advantage8: '品牌可靠',
    des8: '復星旗下 中國民營企業500強前50名',
    btnText: '立即開戶',
    btnText2: '立即下載',
    btnText3: '立即參與',
    thsTip: '您有未完成的開戶流程，請使用瀏覽器訪問以下鏈接繼續完成開戶',
    organTip: '該手機號已綁定交易賬戶，該類型賬戶即將開放線上交易功能，敬請期待！',
    confirm: '確定',
    cancel: '取消',
    know: '知道了',
    ndkhywc: '您的開戶已完成',
    hcydjwckhl: '還差壹點就完成開戶啦！<br/>請繼續填寫資料，完成開戶。',
    jvkh: '繼續開戶',
    isLogin: '已有賬戶？直接登錄',
    tip: '提示',
    openAccountStrictContent: {
        confirmButtonText: '切換開戶方式',
        tip1: '非常抱歉，目前無法為中國境內投資者提供開戶服務，您可以通過網上轉賬開戶繼續開通證券賬戶',
        tip2: '非常抱歉，目前無法為中國境內投資者提供開戶服務',
        tip3: '溫馨提示：切換開戶方式，您當前的開戶申請將會失效',
        tip5: '請前往星財富APP繼續完成開戶',
        tip6: '請授權使用您當前的位置後再繼續進行開戶',
        gotoAppBtn: '立即前往',
        gotoSettingBtn: '去設置',
        getAppLocationToastMessage: '獲取中...',
    },
    mrStatus: {
        tip: {
            span1: '為提升系統體驗，正在進行',
            span2: '系統維護',
            span3: '。開戶、出入金、換匯、提交訂單等操作將受影響無法使用。同時，系統可能不能正常查詢您的資金、持倉、交易歷史等，待系統維護後會恢復正常。如對閣下造成不便，為此深表歉意。',
        },
    },

    一站式全球财富管理平台: '一站式全球財富管理平台',
    '覆盖港股、美股、沪深港通全球主要市场': '覆蓋港股、美股、滬深港通全球主要市場',
    '基金、债券、另类投资应有尽有': '基金、債券、另類投資應有盡有',
    存款方式多样化: '存款方式多樣化',
    支持eDDA快速存款: '支持eDDA快速存款',
    '支持转数快、银行转账等提供安全便捷等快速入金服务': '支持轉數快、銀行轉賬等提供安全便捷等快速入金服務',
    tips: '溫馨提示',
    promptText: '系統識別到當前手機號具備未完成的企業戶開戶任務，請前往Web版完成企業開戶。',
    openAccountLimitPopInfo: {
      title: '內地投資者開戶聲明',
    },
    openProtocolContent: {
      first: '本人已閱讀、理解並同意',
      second: '內地投資者開立投資賬戶聲明及同意條款',
      third: '全部聲明內容，確認自願簽署',
    },
    agreementAndItems: {
      first: '本人同意',
      second: '電子簽名的同意書',
      thirt: '，通過輸入交易密碼及一次性短訊驗證碼等電子方式，以進行',
      fourth: '內地投資者開立投資賬戶聲明及同意條款',
      fifth:
        '確認及簽署文件。本人明白此電子簽署方式符合香港《電子交易條例》（第553章）規定，並與本人親筆簽名具有同等法律效力',
    },
    signErrorTxt: '簽署失敗，稍後重試',
}
